import { render, staticRenderFns } from "./ManagedAccountQuestions.vue?vue&type=template&id=617f98a6"
import script from "./ManagedAccountQuestions.vue?vue&type=script&lang=ts"
export * from "./ManagedAccountQuestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports